import { React, useEffect } from "react";
import { Grid, TextField, FormControlLabel, Checkbox, Autocomplete, Stack, Typography, FormHelperText, FormControl, Radio, RadioGroup, Paper, MenuItem } from "@mui/material";

const CommonStep = ({ commonFormik, countryData, stateData, getStateData, isEditing, isEditMode }) => {

    useEffect(() => {
        if (commonFormik.values.companyCountry) {
            getStateData(commonFormik.values.companyCountry);
        }
    }, [commonFormik.values.companyCountry]);

    if (!commonFormik || !commonFormik.values) {
        return null; // or a loader
    }
    return (
        <>
            {/* Form */}
            <Grid container spacing={2} rowSpacing={2.5}>

                {/* First Name */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        First Name
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="firstName"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                height: "42px",
                            },
                        }}
                        value={commonFormik?.values?.firstName}
                        onChange={commonFormik.handleChange}
                        error={commonFormik?.touched?.firstName && Boolean(commonFormik?.errors?.firstName)}
                        helperText={commonFormik?.touched?.firstName && commonFormik?.errors?.firstName}
                    />
                </Grid>

                {/* Last Name */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}>
                        Last Name
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="lastName"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                height: "42px",
                            },
                        }}
                        value={commonFormik?.values?.lastName}
                        onChange={commonFormik.handleChange}
                        error={commonFormik?.touched?.lastName && Boolean(commonFormik?.errors?.lastName)}
                        helperText={commonFormik?.touched?.lastName && commonFormik?.errors?.lastName}
                    />
                </Grid>

                {/* Email */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        Email
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="email"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                height: "42px",
                            },
                        }}
                        value={commonFormik?.values?.email}
                        onChange={commonFormik.handleChange}
                        error={commonFormik?.touched?.email && Boolean(commonFormik?.errors?.email)}
                        helperText={commonFormik?.touched?.email && commonFormik?.errors?.email}
                    />
                </Grid>

                {/* Phone */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        Company Phone Number
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="companyPhoneNumber"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                height: "42px",
                            },
                        }}
                        value={commonFormik?.values?.companyPhoneNumber}
                        onChange={commonFormik.handleChange}
                        onBlur={commonFormik.handleBlur}
                        error={
                            commonFormik?.touched?.companyPhoneNumber &&
                            Boolean(commonFormik?.errors?.companyPhoneNumber)
                        }
                        helperText={
                            commonFormik?.touched?.companyPhoneNumber &&
                            commonFormik?.errors?.companyPhoneNumber
                        }
                    />
                </Grid>

                {/* Country */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        Country
                    </Typography>
                    <Autocomplete
                        options={countryData || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={
                            (countryData || []).find(
                                (option) => option.name === commonFormik?.values?.companyCountry
                            ) || null
                        }
                        onChange={(event, value) => {
                            commonFormik.setFieldValue("companyCountry", value?.name || "");
                            commonFormik.setFieldValue("companyState", "");
                            getStateData(value?.name);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        height: "42px",
                                    },
                                }}
                                error={
                                    commonFormik?.touched?.companyCountry &&
                                    Boolean(commonFormik?.errors?.companyCountry)
                                }
                                helperText={
                                    commonFormik?.touched?.companyCountry &&
                                    commonFormik?.errors?.companyCountry
                                }
                            />
                        )}
                    />
                </Grid>

                {/* State */}
                <Grid item xs={12} md={6}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        State
                    </Typography>
                    <Autocomplete
                        options={stateData || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={
                            (stateData || []).find(
                                (option) => option.name === commonFormik?.values?.companyState
                            ) ?? null
                        }
                        onChange={(event, value) =>
                            commonFormik.setFieldValue("companyState", value?.name || "")
                        }
                        disabled={!stateData.length}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        height: "42px",
                                    },
                                }}
                                error={
                                    commonFormik?.touched?.companyState &&
                                    Boolean(commonFormik?.errors?.companyState)
                                }
                                helperText={
                                    commonFormik?.touched?.companyState &&
                                    commonFormik?.errors?.companyState
                                }
                            />
                        )}
                    />
                </Grid>

                {/* Address */}
                <Grid item xs={12}>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 0.5,
                            color: "#1f2937",
                        }}
                    >
                        Company Address
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        name="companyAddress"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                minHeight: "42px",
                                mb: 2
                            },
                        }}
                        value={commonFormik?.values?.companyAddress}
                        onChange={commonFormik.handleChange}
                        error={
                            commonFormik?.touched?.companyAddress &&
                            Boolean(commonFormik?.errors?.companyAddress)
                        }
                        helperText={
                            commonFormik?.touched?.companyAddress &&
                            commonFormik?.errors?.companyAddress
                        }
                    />
                </Grid>

                {/* Products */}
                <Grid item xs={12}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            border: "1px solid #e5e7eb",
                            borderRadius: "12px",
                            backgroundColor: "#fafbff",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "14px",
                                fontWeight: 600,
                                mb: 1.5,
                                color: "#1f2937",
                            }}
                        >
                            Select Products
                        </Typography>

                        <Stack
                            direction="row"
                            spacing={2}
                            flexWrap="wrap"
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isQbot"
                                        checked={commonFormik?.values?.isQbot}
                                        disabled={isEditMode}
                                        onChange={(e) =>
                                            commonFormik.setFieldValue(
                                                "isQbot",
                                                e.target.checked
                                            )
                                        }
                                        sx={{
                                            color: "#25429b",
                                            "&.Mui-checked": {
                                                color: "#25429b",
                                            },
                                        }}
                                    />
                                }
                                label="QBot"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isPaycentral"
                                        checked={commonFormik?.values?.isPaycentral}
                                        disabled={isEditMode}
                                        onChange={(e) =>
                                            commonFormik.setFieldValue(
                                                "isPaycentral",
                                                e.target.checked
                                            )
                                        }
                                        sx={{
                                            color: "#25429b",
                                            "&.Mui-checked": {
                                                color: "#25429b",
                                            },
                                        }}
                                    />
                                }
                                label="PayCentral"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isKyc"
                                        checked={commonFormik?.values?.isKyc}
                                        disabled={isEditMode}
                                        onChange={(e) =>
                                            commonFormik.setFieldValue(
                                                "isKyc",
                                                e.target.checked
                                            )
                                        }
                                        sx={{
                                            color: "#25429b",
                                            "&.Mui-checked": {
                                                color: "#25429b",
                                            },
                                        }}
                                    />
                                }
                                label="KYC"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isTripola"
                                        checked={commonFormik?.values?.isTripola}
                                        disabled={isEditMode}
                                        onChange={(e) =>
                                            commonFormik.setFieldValue(
                                                "isTripola",
                                                e.target.checked
                                            )
                                        }
                                        sx={{
                                            color: "#25429b",
                                            "&.Mui-checked": {
                                                color: "#25429b",
                                            },
                                        }}
                                    />
                                }
                                label="Tripola"
                            />
                        </Stack>

                        {commonFormik?.touched?.atLeastOneProduct &&
                            commonFormik?.errors?.atLeastOneProduct && (
                                <FormHelperText>
                                    {commonFormik.errors.atLeastOneProduct}
                                </FormHelperText>
                            )}
                    </Paper>
                </Grid>

                {/* Trial Configuration */}
                {isEditMode && (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                border: "1px solid #e5e7eb",
                                borderRadius: "12px",
                                backgroundColor: "#fafbff",
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={commonFormik.values.isTrialConfig}
                                        disabled={commonFormik.values?.hasTrialConfiguration}
                                        onChange={(e) => {
                                            commonFormik.setFieldValue(
                                                "isTrialConfig",
                                                e.target.checked
                                            );
                                            commonFormik.setFieldTouched("trialPortal", true);

                                            if (!e.target.checked) {
                                                commonFormik.setFieldValue("trialPortal", "");
                                                commonFormik.setFieldValue("trialDays", "");
                                                commonFormik.setFieldValue("graceDays", "");
                                            }
                                        }}
                                        sx={{
                                            color: "#25429b",
                                            "&.Mui-checked": {
                                                color: "#25429b",
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            color: "#1f2937",
                                        }}
                                    >
                                        Trial Configuration
                                    </Typography>
                                }
                            />

                            {commonFormik.values.isTrialConfig && (
                                <>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#6b7280",
                                            mb: 2,
                                            ml: 1,
                                        }}
                                    >
                                        Select the trial portal for this client
                                    </Typography>

                                    <RadioGroup
                                        row
                                        value={commonFormik.values.trialPortal}
                                        onChange={(e) =>
                                            commonFormik.setFieldValue(
                                                "trialPortal",
                                                e.target.value
                                            )
                                        }
                                        sx={{
                                            "& .MuiFormControlLabel-root": {
                                                margin: 0,
                                            },
                                        }}
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            flexWrap="wrap"
                                        >
                                            {(!commonFormik.values.isQbot || commonFormik.values.trialPortal === "qbot") && (
                                                <Paper
                                                    sx={{
                                                        px: 1.5,
                                                        py: 0.5,
                                                        borderRadius: "8px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border:
                                                            commonFormik.values.trialPortal ===
                                                                "qbot"
                                                                ? "2px solid #25429b"
                                                                : "1px solid #d1d5db",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="qbot"
                                                        control={
                                                            <Radio
                                                                disabled={commonFormik.values?.hasTrialConfiguration}
                                                                size="small"
                                                                sx={{
                                                                    p: 0.25,
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 18,
                                                                    },
                                                                    color: "#25429b",
                                                                    "&.Mui-checked": {
                                                                        color: "#25429b",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="QBot"
                                                        sx={{
                                                            m: 0,
                                                            gap: 0.5,
                                                            alignItems: "center",

                                                            "& .MuiTypography-root": {
                                                                fontSize: "14px",
                                                                lineHeight: 1,
                                                            },

                                                            "& .MuiButtonBase-root": {
                                                                padding: "2px",
                                                            },
                                                        }}
                                                    />
                                                </Paper>
                                            )}

                                            {(!commonFormik.values.isPaycentral || commonFormik.values.trialPortal === "paycentral") && (
                                                <Paper
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        borderRadius: "10px",
                                                        border:
                                                            commonFormik.values.trialPortal ===
                                                                "paycentral"
                                                                ? "2px solid #25429b"
                                                                : "1px solid #d1d5db",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="paycentral"
                                                        control={
                                                            <Radio size="small"
                                                                disabled={commonFormik.values?.hasTrialConfiguration}
                                                                sx={{
                                                                    p: 0.25,
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 18,
                                                                    },
                                                                    color: "#25429b",
                                                                    "&.Mui-checked": {
                                                                        color: "#25429b",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="PayCentral"
                                                        sx={{
                                                            m: 0,
                                                            gap: 0.5,
                                                            alignItems: "center",

                                                            "& .MuiTypography-root": {
                                                                fontSize: "14px",
                                                                lineHeight: 1,
                                                            },

                                                            "& .MuiButtonBase-root": {
                                                                padding: "2px",
                                                            },
                                                        }}
                                                    />
                                                </Paper>
                                            )}

                                            {(!commonFormik.values.isKyc || commonFormik.values.trialPortal === "kyc") && (
                                                <Paper
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        borderRadius: "10px",
                                                        border:
                                                            commonFormik.values.trialPortal ===
                                                                "kyc"
                                                                ? "2px solid #25429b"
                                                                : "1px solid #d1d5db",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="kyc"
                                                        control={
                                                            <Radio size="small"
                                                                disabled={commonFormik.values?.hasTrialConfiguration}
                                                                sx={{
                                                                    p: 0.25,
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 18,
                                                                    },
                                                                    color: "#25429b",
                                                                    "&.Mui-checked": {
                                                                        color: "#25429b",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="KYC"
                                                        sx={{
                                                            m: 0,
                                                            gap: 0.5,
                                                            alignItems: "center",

                                                            "& .MuiTypography-root": {
                                                                fontSize: "14px",
                                                                lineHeight: 1,
                                                            },

                                                            "& .MuiButtonBase-root": {
                                                                padding: "2px",
                                                            },
                                                        }}
                                                    />
                                                </Paper>
                                            )}

                                            {(!commonFormik.values.isTripola || commonFormik.values.trialPortal === "tripola") && (
                                                <Paper
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        borderRadius: "10px",
                                                        border:
                                                            commonFormik.values.trialPortal ===
                                                                "tripola"
                                                                ? "2px solid #25429b"
                                                                : "1px solid #d1d5db",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="tripola"
                                                        control={
                                                            <Radio size="small"
                                                                disabled={commonFormik.values?.hasTrialConfiguration}
                                                                sx={{
                                                                    p: 0.25,
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 18,
                                                                    },
                                                                    color: "#25429b",
                                                                    "&.Mui-checked": {
                                                                        color: "#25429b",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="Tripola"
                                                        sx={{
                                                            m: 0,
                                                            gap: 0.5,
                                                            alignItems: "center",

                                                            "& .MuiTypography-root": {
                                                                fontSize: "14px",
                                                                lineHeight: 1,
                                                            },

                                                            "& .MuiButtonBase-root": {
                                                                padding: "2px",
                                                            },
                                                        }}
                                                    />
                                                </Paper>
                                            )}
                                        </Stack>
                                    </RadioGroup>
                                    {commonFormik.touched.trialPortal &&
                                        commonFormik.errors.trialPortal && (
                                            <FormHelperText error sx={{ ml: 1 }}>
                                                {commonFormik.errors.trialPortal}
                                            </FormHelperText>
                                        )}
                                </>
                            )}

                            {commonFormik.values.isTrialConfig && (
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} md={6}>
                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                mb: 0.5,
                                                color: "#1f2937",
                                            }}
                                        >
                                            Trial Duration (Days)
                                        </Typography>

                                        <TextField
                                            fullWidth
                                            size="small"
                                            type="number"
                                            name="trialDays"
                                            placeholder="Enter trial days"
                                            value={commonFormik.values.trialDays || ""}
                                            onChange={commonFormik.handleChange}
                                            disabled={commonFormik.values?.hasTrialConfiguration}
                                            error={
                                                commonFormik.touched.trialDays &&
                                                Boolean(commonFormik.errors.trialDays)
                                            }
                                            helperText={
                                                commonFormik.touched.trialDays &&
                                                commonFormik.errors.trialDays
                                            }
                                        />
                                    </Grid>

                                    {commonFormik.values?.hasTrialConfiguration && (
                                        <Grid item xs={12} md={6}>
                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    mb: 0.5,
                                                    color: "#1f2937",
                                                }}
                                            >
                                                Grace Period (Days)
                                            </Typography>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                name="graceDays"
                                                placeholder="Enter grace days"
                                                value={commonFormik.values.graceDays ?? ""}
                                                onChange={commonFormik.handleChange}
                                                error={
                                                    commonFormik.touched.graceDays &&
                                                    Boolean(commonFormik.errors.graceDays)
                                                }
                                                helperText={
                                                    commonFormik.touched.graceDays &&
                                                    commonFormik.errors.graceDays
                                                }
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                        </Paper>
                    </Grid>
                )}

            </Grid>
        </>
    );
};

export default CommonStep;